import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Col, Container, Row } from "reactstrap";
import MapWithMarkers from "../map";
import { TDevice } from "../../../../../common/types";
import { TNullable } from "../../../../../common/types/common";
import useAuthUser from "../../../../../common/hooks/authUser";

const Devices = () => {
    const [selectedDevice, setSelectedDevice] = useState<TNullable<TDevice>>(null);
    const { user } = useAuthUser();

    // Use dealerDevices from the user object
    const data = useMemo(() => user?.dealerDevices || [], [user?.dealerDevices]);

    const deviceList = useMemo(() => data?.map((device) => {
        // TMachine type doesn't include lastKnownLocation, but the actual data may have it
        const deviceWithLocation = device as TDevice;
        const hasLocation = 'lastKnownLocation' in device && deviceWithLocation.lastKnownLocation;
        return (
            <div key={`device-row-${device.serialNumber}`} className="d-flex justify-content-between mb-2">
                {hasLocation
                    ? (
                        <a
                            className="fs-16 fw-bold"
                            onClick={() => { setSelectedDevice(deviceWithLocation); }}
                            title="Show device on the map"
                        >{device.serialNumber}</a>
                    ) : device.serialNumber
                }

                <Link
                    to={`/machines/${device.serialNumber}`}
                    className="fs-16 fw-bold"
                >
                    <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </Link>
            </div>
        );
    }), [data]);

    const devicesWithCoords = useMemo(() => data ? data.filter((device): device is TDevice => 'lastKnownLocation' in device && !!(device as TDevice).lastKnownLocation) : [],[data]);

    return (
        <Container fluid className="m-0 p-0">
            <Row>
                <Col xl={9} lg={12} className="mb-3">
                    <Card className="h-100">
                        <CardHeader>
                            <CardTitle>Last Location</CardTitle>
                        </CardHeader>
                        <CardBody className="pt-0 pb-0">
                            <div style={{height: '500px'}}>
                                <MapWithMarkers
                                    devices={devicesWithCoords}
                                    selectedDevice={selectedDevice}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} lg={12} className="mb-3">
                    <Card className="h-100">
                        <CardHeader>
                            <CardTitle>Dealer Machines</CardTitle>
                        </CardHeader>
                        <CardBody>
                            {deviceList?.length ? deviceList : "No machines yet"}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </Container>
    );
};

export default Devices;
